
export const appConf = {
    name: 'Pension ...',
    logo: '/assets/images/logo-icon.png',
    login: {
        title: 'Connectez-vous',
        text: 'Please log in to your account'
    },
    forgot: {
        title: 'Forgot Password ?',
        text: 'Enter your email to reset password'
    },

}